import SlimSelect from "slim-select";

export default function ProductPopup() {
    productPopup();
}

const modalWindow = document.getElementById("productModal");
const finishes_select = modalWindow.querySelector("#finishes");

let slim;

function productPopup() {
    const modalTriggers = document.getElementsByClassName("product-modal");

    for (let i = 0; i < modalTriggers.length; i++) {
        modalTriggers[i].onclick = function () {
            const chipColour = this.getAttribute("data-colour");
            const convertRgb = chipColour.split(", ");
            const hexCode = rgbToHex(parseInt(convertRgb[0]), parseInt(convertRgb[1]), parseInt(convertRgb[2]));
            const hexFormatted = hexCode.replace(/#/g, "");

            document.querySelector(".product-img-popup").setAttribute("src", this.getAttribute("data-image"));
            document.querySelector(".product-img-popup").setAttribute("alt", this.getAttribute("data-name"));
            document.querySelector(".product-name-popup").innerHTML = this.getAttribute("data-name");
            document.querySelector(".product-colour-popup").setAttribute("style", `background-color: rgb(${chipColour})`);
            document.querySelector(".product-colour-name-popup").innerHTML = this.getAttribute("data-chip");
            document.querySelector(".product-ref-popup").innerHTML = this.getAttribute("data-ref");

            var isTrade = this.getAttribute("data-istrade");

            var retailLink = document.querySelector(".submit-with-arrow span.retail-link");
            var tradeLink = document.querySelector(".submit-with-arrow span.trade-link");

            if (isTrade !== 'true') {
                tradeLink.setAttribute("style", "display:none");
                retailLink.removeAttribute("style");
            }
            else {
                retailLink.setAttribute("style", "display:none");
                tradeLink.removeAttribute("style");
            }

            const colour_ref = this.getAttribute("data-ref");
            const colour_name = this.getAttribute("data-chip").replace(/ /g, "%20");
            const bqDetails = JSON.parse(this.getAttribute("data-bq"));

            if (slim) {
                slim.destroy();
                slim = null;
            }

            const oldSlimSelectContainer = document.querySelectorAll(".ss-main");
            oldSlimSelectContainer.forEach(el => el.remove());

            finishes_select.innerHTML = "";
            bqDetails.forEach((obj, index) => {
                const option = document.createElement("option");
                option.text = obj.BQType;
                option.value = obj.BQType;
                finishes_select.add(option);


                if (index === 0) {
                    setUrl(obj, colour_ref, colour_name, hexFormatted);
                }
            });

            slim = new SlimSelect({
                select: finishes_select,
                settings: {
                    showSearch: false
                }
            });

            finishes_select.addEventListener("change", function (e) {
                let item = bqDetails[this.selectedIndex];
                setUrl(item, colour_ref, colour_name, hexFormatted);
            });

            modalWindow.classList.add("open");
        };
    }
}

function closeModal() {
    const closeButtons = document.getElementsByClassName("product-popup-close");

    for (let i = 0; i < closeButtons.length; i++) {
        closeButtons[i].onclick = function () {
            const modalWindow = this.parentNode.parentNode;

            modalWindow.classList.remove("open");

            if (slim) {
                slim.destroy();
                slim = null;
            }

            finishes_select.innerHTML = "";
        };
    }
}

function setUrl(item, colour_ref, colour_name, hexFormatted) {
    const base_url = item.BQLink;
    const product_ref = item.BQRef;
    const url = `${base_url}/${colour_ref}/${product_ref}`;
    document.querySelector(".submit-with-arrow .button").href = url;
}

function ready(fn) {
    if (document.readyState !== "loading") {
        fn();
    } else {
        document.addEventListener("DOMContentLoaded", fn);
    }
}

ready(closeModal);

function componentToHex(c) {
    if (c) {
        const hex = c.toString(16);
        return hex.length === 1 ? "0" + hex : hex;
    }
}

function rgbToHex(r, g, b) {
    return "#" + componentToHex(r) + componentToHex(g) + componentToHex(b);
}